// Network status banner component
// CREATED: Shows connection status at the top of the screen
// Features: Auto-hide on reconnection, persistent while offline, slide animation

import { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

export function NetworkStatusBanner() {
  const { isOnline, wasOffline } = useNetworkStatus();
  const [showBanner, setShowBanner] = useState(!isOnline);

  useEffect(() => {
    if (!isOnline) {
      // Show banner when offline
      setShowBanner(true);
    } else if (wasOffline) {
      // Show "reconnected" banner briefly
      setShowBanner(true);
      const timer = setTimeout(() => {
        setShowBanner(false);
      }, 3000);
      return () => clearTimeout(timer);
    } else {
      setShowBanner(false);
    }
  }, [isOnline, wasOffline]);

  if (!showBanner) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[100] h-10 flex items-center justify-center gap-2 text-white text-sm font-medium transition-transform duration-300 ${
        isOnline
          ? 'bg-green-600'
          : 'bg-orange-600'
      } pt-[env(safe-area-inset-top)] animate-slideDown`}
      role="alert"
      aria-live="polite"
    >
      {isOnline ? (
        <>
          <Wifi size={16} />
          <span>Connexion rétablie</span>
        </>
      ) : (
        <>
          <WifiOff size={16} />
          <span>Mode hors ligne</span>
        </>
      )}
      <style>{`
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
          }
          to {
            transform: translateY(0);
          }
        }
        .animate-slideDown {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}
